import produce from 'immer';
import { Reducer } from 'redux';

import { IReportActionsType, IReportState, IReportTypes } from './types';

export const INITIAL_STATE: IReportState = {
  loading: false,
  loadingGeneratedReports: false,
  loadingGenerateReport: false,
  reports: [],
  totalReports: 0,
  generatedReports: [],
  totalGeneratedReports: 0,
};

const Reports: Reducer<IReportState, IReportActionsType> = (
  state = INITIAL_STATE,
  action: IReportActionsType,
) => {
  return produce(state, (draft) => {
    switch (action.type) {
      case IReportTypes.GET_REPORTS_REQUEST: {
        draft.loading = true;
        break;
      }
      case IReportTypes.GET_REPORTS_SUCCESS: {
        draft.loading = false;
        draft.reports = action.payload.reports;
        draft.totalReports = action.payload.totalReports;
        break;
      }
      case IReportTypes.GET_REPORTS_FAILURE: {
        draft.loadingGenerateReport = false;
        break;
      }
      case IReportTypes.GENERATE_REPORT_REQUEST: {
        draft.loadingGenerateReport = true;
        break;
      }
      case IReportTypes.GENERATE_REPORT_SUCCESS: {
        draft.loadingGenerateReport = false;
        break;
      }
      case IReportTypes.GENERATE_REPORT_FAILURE: {
        draft.loadingGenerateReport = false;
        break;
      }
      case IReportTypes.GET_GENERATED_REPORTS_REQUEST: {
        draft.loadingGeneratedReports = true;
        break;
      }
      case IReportTypes.GET_GENERATED_REPORTS_SUCCESS: {
        draft.loadingGeneratedReports = false;
        draft.generatedReports = action.payload.generatedReports;
        draft.totalGeneratedReports = action.payload.totalGeneratedReports;
        break;
      }
      case IReportTypes.GET_GENERATED_REPORTS_FAILURE: {
        draft.loadingGeneratedReports = false;
        break;
      }
      default:
    }
  });
};

export default Reports;
